import { useMemo, useState } from 'react';
import { ICONOS_PRESET_CATEGORIA } from '../../utils/iconosCategoria';

/**
 * Popup "ver más íconos" (HU-014) — la librería completa de
 * `ICONOS_PRESET_CATEGORIA` (100+) no cabe cómoda dentro del formulario de
 * categoría, así que el formulario solo muestra los frecuentes y este modal
 * hace de buscador sobre el resto. `onSeleccionar(clase)` cierra el popup
 * solo, es responsabilidad de quien lo abre.
 */
const ModalSelectorIcono = ({ onSeleccionar, onCerrar }) => {
  const [busqueda, setBusqueda] = useState('');

  const iconosFiltrados = useMemo(() => {
    const texto = busqueda.trim().toLowerCase();
    if (!texto) return ICONOS_PRESET_CATEGORIA;
    return ICONOS_PRESET_CATEGORIA.filter((icono) =>
      icono.etiqueta.toLowerCase().includes(texto) || icono.clase.toLowerCase().includes(texto)
    );
  }, [busqueda]);

  return (
    <div className="panel-gu-modal-fondo" onClick={onCerrar}>
      <div className="panel-gu-modal panel-selector-icono-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Elegir ícono</h3>
        <input
          type="text"
          className="panel-input"
          placeholder="Buscar ícono (ej. agua, ruido, seguridad…)"
          autoFocus
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />

        <div className="panel-config-iconos-grid panel-selector-icono-grid-completo">
          {iconosFiltrados.map((icono) => (
            <button
              key={icono.clase}
              type="button"
              title={icono.etiqueta}
              className="panel-config-icono-opcion"
              onClick={() => onSeleccionar(icono.clase)}
            >
              <i className={`fas ${icono.clase}`}></i>
            </button>
          ))}
          {iconosFiltrados.length === 0 && (
            <p className="panel-texto-ayuda">Sin resultados para "{busqueda}".</p>
          )}
        </div>

        <div className="panel-gu-modal-botones">
          <button type="button" className="panel-boton-secundario" onClick={onCerrar}>Cerrar</button>
        </div>
      </div>
    </div>
  );
};

export default ModalSelectorIcono;
